module.exports = __webpack_public_path__ + "media/images/dispatcher-03272965af5c29174aa8c30eae5ffbb355c5f4e0f6e36d2085c16a958e82bc42.svg";